import { render, staticRenderFns } from "./TotalTicketsSoldToday.vue?vue&type=template&id=cc474a30"
import script from "./TotalTicketsSoldToday.vue?vue&type=script&lang=js"
export * from "./TotalTicketsSoldToday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports